import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  hr: {
    translation: {
      brand: "Travelina",
      nav: {
        home: "Naslovnica",
        tours: "Putovanja",
        destinations: "Destinacije",
        reviews: "Iskustva",
        contact: "Kontakt",
        blog: "Blog",
      },
      hero: {
        kicker: "Putnička agencija · Travelina",
        titleLine1: "Istraži svijet",
        titleLine2: "s Travelinom",
        subtitle:
          "Putovanja u manjim grupama, personalizirane ture i potpuna podrška na hrvatskom jeziku.",
        ctaPrimary: "Pogledaj putovanja",
        ctaSecondary: "Pošalji upit",
        stat1: "+120 organiziranih putovanja",
        stat2: "Ocjena putnika 4.9/5",
      },
      tours: {
        sectionTitle: "Nadolazeća putovanja",
        sectionSubtitle:
          "Biramo provjerene destinacije, lokalne vodiče i fleksibilne itinerare.",
        filterAll: "Sva",
        filterBeach: "More",
        filterCity: "Gradovi",
        filterAdventure: "Avantura",
        filterRomantic: "Romantično",
        noTours: "Trenutno nema putovanja za tu kategoriju.",
        from: "od",
        perPerson: "po osobi",
        nights: "noćenja",
        btnDetails: "Detalji",
      },
      destinations: {
        sectionTitle: "Najtraženije destinacije",
        sectionSubtitle:
          "Ovo su odredišta u koja se naši putnici najradije vraćaju.",
        item1Title: "Barcelona & Costa Brava",
        item1Text: "Spoj grada, plaže i mediteranske hrane.",
        item2Title: "Meksički Karibi",
        item2Text: "Tirkizno more, cenote i povijest Maja.",
        item3Title: "Toskana i Cinque Terre",
        item3Text: "Vino, sela na brežuljcima i šareni gradići uz more.",
      },
      reviews: {
        sectionTitle: "Iskustva putnika",
        sectionSubtitle:
          "Pravi dojmovi ljudi koji su već putovali s Travelinom.",
      },
      contact: {
        sectionTitle: "Pošalji nam ideju putovanja",
        sectionSubtitle:
          "Napiši nam što te zanima i složit ćemo prijedlog putovanja po tvojoj mjeri.",
        name: "Ime i prezime",
        email: "Email",
        destination: "Željena destinacija",
        month: "Mjesec putovanja",
        people: "Broj osoba",
        message: "Poruka / detalji",
        btnSend: "Pošalji upit",
        success: "Hvala! Javit ćemo se u najkraćem roku.",
      },
      footer: {
        rights: "Sva prava pridržana.",
        links: "Uvjeti putovanja · Privatnost · Kolačići",
      },
      blog: {
        pageTitle: "Blog putovanja",
        pageSubtitle: "Istražite naša putovanja i doživite nezaboravne avanture.",
        days: "dana",
        btnReadMore: "Pročitaj više",
      },
    },
  },
  en: {
    translation: {
      brand: "Travelina",
      nav: {
        home: "Home",
        tours: "Tours",
        destinations: "Destinations",
        reviews: "Reviews",
        contact: "Contact",
        blog: "Blog",
      },
      hero: {
        kicker: "Travel agency · Travelina",
        titleLine1: "Explore the world",
        titleLine2: "with Travelina",
        subtitle:
          "Small group trips, tailor-made itineraries and full support in English.",
        ctaPrimary: "View trips",
        ctaSecondary: "Send inquiry",
        stat1: "+120 organized trips",
        stat2: "Traveler rating 4.9/5",
      },
      tours: {
        sectionTitle: "Upcoming trips",
        sectionSubtitle:
          "We carefully select destinations, local guides and flexible itineraries.",
        filterAll: "All",
        filterBeach: "Beach",
        filterCity: "Cities",
        filterAdventure: "Adventure",
        filterRomantic: "Romantic",
        noTours: "Currently no trips for this category.",
        from: "from",
        perPerson: "per person",
        nights: "nights",
        btnDetails: "Details",
      },
      destinations: {
        sectionTitle: "Popular destinations",
        sectionSubtitle:
          "These are the places our travelers love to return to.",
        item1Title: "Barcelona & Costa Brava",
        item1Text: "City vibes, beaches and Mediterranean food.",
        item2Title: "Mexican Caribbean",
        item2Text: "Turquoise water, cenotes and Mayan history.",
        item3Title: "Tuscany & Cinque Terre",
        item3Text: "Wine, hilltop villages and colorful seaside towns.",
      },
      reviews: {
        sectionTitle: "What our travelers say",
        sectionSubtitle: "Real feedback from people who traveled with us.",
      },
      contact: {
        sectionTitle: "Tell us about your trip idea",
        sectionSubtitle:
          "Share what you have in mind and we'll prepare a tailor-made proposal.",
        name: "Full name",
        email: "Email",
        destination: "Desired destination",
        month: "Month of travel",
        people: "Number of people",
        message: "Message / details",
        btnSend: "Send inquiry",
        success: "Thank you! We will get back to you shortly.",
      },
      footer: {
        rights: "All rights reserved.",
        links: "Terms · Privacy · Cookies",
      },
      blog: {
        pageTitle: "Travel Blog",
        pageSubtitle: "Explore our trips and experience unforgettable adventures.",
        days: "days",
        btnReadMore: "Read more",
      },
    },
  },
  de: {
    translation: {
      brand: "Travelina",
      nav: {
        home: "Startseite",
        tours: "Reisen",
        destinations: "Reiseziele",
        reviews: "Erfahrungen",
        contact: "Kontakt",
        blog: "Blog",
      },
      hero: {
        kicker: "Reisebüro · Travelina",
        titleLine1: "Entdecke die Welt",
        titleLine2: "mit Travelina",
        subtitle:
          "Kleingruppenreisen, maßgeschneiderte Routen und deutschsprachige Betreuung.",
        ctaPrimary: "Reisen ansehen",
        ctaSecondary: "Anfrage senden",
        stat1: "+120 organisierte Reisen",
        stat2: "Bewertung 4,9/5",
      },
      tours: {
        sectionTitle: "Bevorstehende Reisen",
        sectionSubtitle:
          "Sorgfältig ausgewählte Ziele, lokale Guides und flexible Programme.",
        filterAll: "Alle",
        filterBeach: "Meer",
        filterCity: "Städte",
        filterAdventure: "Abenteuer",
        filterRomantic: "Romantik",
        noTours: "Zurzeit keine Reisen in dieser Kategorie.",
        from: "ab",
        perPerson: "pro Person",
        nights: "Nächte",
        btnDetails: "Details",
      },
      destinations: {
        sectionTitle: "Beliebte Reiseziele",
        sectionSubtitle:
          "Orte, an die unsere Reisenden immer wieder zurückkehren.",
        item1Title: "Barcelona & Costa Brava",
        item1Text: "Stadt, Strand und mediterrane Küche.",
        item2Title: "Mexikanische Karibik",
        item2Text: "Türkises Meer, Cenoten und Maya-Geschichte.",
        item3Title: "Toskana & Cinque Terre",
        item3Text: "Wein, Hügellandschaften und bunte Küstenorte.",
      },
      reviews: {
        sectionTitle: "Erfahrungsberichte",
        sectionSubtitle:
          "Echte Bewertungen von Reisenden, die mit uns unterwegs waren.",
      },
      contact: {
        sectionTitle: "Erzähle uns von deiner Reiseidee",
        sectionSubtitle:
          "Schreibe uns deine Wünsche und wir erstellen ein individuelles Angebot.",
        name: "Name und Nachname",
        email: "E-Mail",
        destination: "Gewünschtes Reiseziel",
        month: "Reisemonat",
        people: "Personenanzahl",
        message: "Nachricht / Details",
        btnSend: "Anfrage senden",
        success: "Danke! Wir melden uns in Kürze.",
      },
      footer: {
        rights: "Alle Rechte vorbehalten.",
        links: "AGB · Datenschutz · Cookies",
      },
      blog: {
        pageTitle: "Reiseblog",
        pageSubtitle: "Entdecken Sie unsere Reisen und erleben Sie unvergessliche Abenteuer.",
        days: "Tage",
        btnReadMore: "Mehr lesen",
      },
    },
  },
  es: {
    translation: {
      brand: "Travelina",
      nav: {
        home: "Inicio",
        tours: "Viajes",
        destinations: "Destinos",
        reviews: "Opiniones",
        contact: "Contacto",
        blog: "Blog",
      },
      hero: {
        kicker: "Agencia de viajes · Travelina",
        titleLine1: "Explora el mundo",
        titleLine2: "con Travelina",
        subtitle:
          "Grupos reducidos, itinerarios a medida y acompañamiento en español.",
        ctaPrimary: "Ver viajes",
        ctaSecondary: "Enviar consulta",
        stat1: "+120 viajes organizados",
        stat2: "Valoración 4,9/5",
      },
      tours: {
        sectionTitle: "Próximos viajes",
        sectionSubtitle:
          "Seleccionamos destinos, guías locales y programas flexibles.",
        filterAll: "Todos",
        filterBeach: "Playa",
        filterCity: "Ciudades",
        filterAdventure: "Aventura",
        filterRomantic: "Romántico",
        noTours: "No hay viajes en esta categoría por ahora.",
        from: "desde",
        perPerson: "por persona",
        nights: "noches",
        btnDetails: "Detalles",
      },
      destinations: {
        sectionTitle: "Destinos populares",
        sectionSubtitle:
          "Lugares a los que nuestros viajeros siempre quieren volver.",
        item1Title: "Barcelona & Costa Brava",
        item1Text: "Ciudad, playa y gastronomía mediterránea.",
        item2Title: "Caribe mexicano",
        item2Text: "Agua turquesa, cenotes y cultura maya.",
        item3Title: "Toscana & Cinque Terre",
        item3Text: "Vino, pueblos en colinas y costa colorida.",
      },
      reviews: {
        sectionTitle: "Lo que dicen los viajeros",
        sectionSubtitle:
          "Opiniones reales de personas que han viajado con Travelina.",
      },
      contact: {
        sectionTitle: "Cuéntanos tu idea de viaje",
        sectionSubtitle:
          "Explícanos qué tienes en mente y preparamos una propuesta a medida.",
        name: "Nombre y apellidos",
        email: "Correo electrónico",
        destination: "Destino deseado",
        month: "Mes de viaje",
        people: "Personas",
        message: "Mensaje / detalles",
        btnSend: "Enviar consulta",
        success: "¡Gracias! Nos pondremos en contacto contigo muy pronto.",
      },
      footer: {
        rights: "Todos los derechos reservados.",
        links: "Condiciones · Privacidad · Cookies",
      },
      blog: {
        pageTitle: "Blog de viajes",
        pageSubtitle: "Explora nuestros viajes y vive aventuras inolvidables.",
        days: "días",
        btnReadMore: "Leer más",
      },
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "hr",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
